import React from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {sendInput} from "game/app/actions/game-instance-actions";
import GameComponent from "game/app/components/game/game-component";
import {Link, Redirect} from "react-router-dom";
import SummaryTable from "../../../common/summary-table";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome/index.es";
import VideoBtn from "game/app/components/video-btn";

class Summary extends GameComponent {

    render() {
        let summaryTable = this.getInstanceProperty('SUMMARY_TABLE');
        if (!summaryTable) {
            return (<Redirect to={`/game/${this.getInstanceId()}/`}/>);
        }

        return (
            <div className='container-fluid'>
                <div className='separate-bottom text-right float-right'>
                    <VideoBtn videoId='LLMV1id3fBY'><FontAwesomeIcon icon={['fas', 'play']} /> Video o rozpočtu</VideoBtn>
                </div>
                <h1 className='page-title-minor separate-bottom'>Rozpočet</h1>
                <SummaryTable/>
                <div className='text-center separate-bottom'>
                    <Link to={`/game/${this.getInstanceId()}/round-1/otazky`} className='btn btn-primary wide-btn'>Pokračovat k úkolům</Link>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state,ownProps) {

    return {
        gameInstance: state.gameInstance,
        knowledgeQuestions: state.knowledgeQuestions,
    };
}

function matchDispatchToProps(dispatch){
    return bindActionCreators({
        sendInput: sendInput
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Summary);
